<template>
  <div class="projectListView-all-box">
    <card>
      <form-table-page
        class="index-all-box"
        :data="formData"
        :label="formLabel"
        @Query="Query"
        @Reset="Reset"
      >
        <template slot="companyId">
          <!-- <el-input v-model="formData.companyName" :placeholder="$t('queryForm.pleaseEnter')" /> -->
          <el-select
            v-model="formData.companyId"
            filterable
            remote
            style="width:100%"
            :placeholder="$t('queryForm.pleaseSelect')"
            :remote-method="companyRemoteMethod"
            :loading="cloading"
            clearable
          >
            <el-option
              v-for="(item,i) in myCompanyList"
              :key="i"
              :value="item.id"
              :label="item.companyName"
            />
          </el-select>
        </template>
        <template slot="projectCode">
          <el-input v-model="formData.projectCode" :placeholder="$t('queryForm.pleaseEnter')" />
        </template>

        <template slot="peojectName">
          <el-input v-model="formData.peojectName" :placeholder="$t('queryForm.pleaseEnter')" />
        </template>

        <template slot="technicalArea">
          <el-select
            v-model="formData.technicalArea"
            style="width:100%"
            :placeholder="$t('queryForm.pleaseSelect')"
            clearable
            @change="technicalAreaChange"
          >
            <el-option
              v-for="(item,i) in technicalAreaList"
              :key="i"
              :value="item.key"
              :label="item.value"
            />
          </el-select>
        </template>

        <template slot="developmentStatusCode">
          <el-select
            v-model="formData.developmentStatusCode"
            style="width:100%"
            :placeholder="$t('queryForm.pleaseSelect')"
            clearable
          >
            <el-option
              v-for="(item,i) in processSelectStageList"
              :key="i"
              :value="item.code"
              :label="item.stageName"
            />
          </el-select>
        </template>

        <template slot="keywords">
          <el-input v-model="formData.keywords" :placeholder="$t('queryForm.pleaseEnter')" />
        </template>

        <template slot="overdue">
          <el-select
            v-model="formData.overdue"
            style="width:100%"
            :placeholder="$t('queryForm.pleaseSelect')"
            clearable
          >
            <el-option value="1" :label="$t('queryForm.yes')" />
            <el-option value="0" :label="$t('queryForm.no')" />
          </el-select>
        </template>

        <!-- 审批状态 : 草稿/待审批/已通过/已拒绝 -->
        <template slot="latestProcessStatus">
          <el-select
            v-model="formData.latestProcessStatus"
            style="width:100%"
            :placeholder="$t('queryForm.pleaseSelect')"
            clearable
          >
            <el-option :label="$t('queryForm.pendingForApproval')" :value="1" />
            <el-option :label="$t('queryForm.approved')" :value="2" />
            <el-option :label="$t('administration.rejected')" :value="3" />
            <el-option :label="$t('queryForm.draft')" :value="4" />
          </el-select>
        </template>

        <!-- 项目状态：未开始/进行中/已完成 -->
        <template slot="startStatus">
          <el-select
            v-model="formData.startStatus"
            style="width:100%"
            :placeholder="$t('queryForm.pleaseSelect')"
            clearable
          >
            <el-option :label="$t('administration.Notyetbegun')" :value="0" />
            <el-option :label="$t('queryForm.inProgress')" :value="1" />
            <el-option :label="$t('queryForm.completed')" :value="2" />
          </el-select>
        </template>
        <!-- 是否启用：启用/禁用 -->
        <!-- <template slot="isAvaliable">
          <el-select
            v-model="formData.isAvaliable"
            style="width:100%"
            :placeholder="$t('queryForm.pleaseSelect')"
            clearable
          >
            <el-option :label="$t('queryForm.enable')" :value="0" />
            <el-option :label="$t('queryForm.disable')" :value="1" />
          </el-select>
        </template> -->
        <!-- 创建人 -->
        <!-- <template slot="createUserId">
          <el-select
            v-model="formData.createUserId"
            filterable
            remote
            style="width:100%"
            :placeholder="$t('queryForm.pleaseSelect')"
            :remote-method="remoteMethod"
            :loading="loading"
            clearable
          >
            <el-option
              v-for="(item,i) in createUserList"
              :key="i"
              :value="item.id"
              :label="item.name"
            />
          </el-select>
        </template> -->
      </form-table-page>
    </card>

    <card style="margin-top: 10px;">
      <div class="table-content-box">
        <div class="btn-list-box form-btn-list">
          <cus-btn v-if="buttonPerCheck('add')" type="add" @click="openAddProject" />
          <!-- <cus-btn v-if="buttonPerCheck('enable')" type="enable" @click="enableBatch(true)" />
          <cus-btn v-if="buttonPerCheck('disable')" type="disable" @click="enableBatch(false)" /> -->
          <cus-btn v-if="buttonPerCheck('delete')" type="delete" @click="deleteBatch" />
          <div v-if="buttonPerCheck('import')" style="float:right">
            <el-button
              type="text"
              style="margin-left:20px"
              @click="downloadTemplate"
            >{{ $t("button.importTemplateDownload") }}</el-button>
            <cus-btn :loading="importLoading" type="import" round @click="openImportPage()" />
          </div>
        </div>

        <table-page
          ref="tablepage"
          :table-data="tableData"
          :search-method="handleSearch"
          :total="total"
          :current-page="currentPage"
          :change-fun="changeTablePage"
          @selectionChange="handleSelectionChange"
        >
          <template slot="tableItem">
            <el-table-column
              prop="companyName"
              :label="$t('formData.companyName')"
              align="center"
              show-overflow-tooltip
              min-width="150"
            />

            <el-table-column
              prop="projectCode"
              :label="$t('formData.projectCode')"
              align="center"
              min-width="150"
              show-overflow-tooltip
            />

            <el-table-column
              prop="peojectName"
              :label="$t('formData.projectName')"
              align="center"
              min-width="150"
              show-overflow-tooltip
            />

            <el-table-column
              prop="technicalArea"
              :label="$t('formData.technicalArea')"
              align="center"
              min-width="150"
            >
              <template slot-scope="scope">
                {{ technicalAreaList.filter(m=>{return m.key===scope.row.technicalArea}).length > 0
                ? technicalAreaList.filter(m=>{return m.key===scope.row.technicalArea})[0].value : '' }}
              </template>
            </el-table-column>
            <el-table-column
              prop="developmentStatusName"
              :label="$t('formData.projectDevelopmentStatus')"
              align="center"
              min-width="250"
              show-overflow-tooltip
            />

            <el-table-column
              prop="keywords"
              :label="$t('formData.keywords')"
              align="center"
              min-width="150"
              show-overflow-tooltip
            />

            <el-table-column
              prop="patentCount"
              :label="$t('formData.patentCount')"
              align="center"
              min-width="150"
              show-overflow-tooltip
            >
              <template slot-scope="item">
                <el-link
                  type="primary"
                  :underline="false"
                  @click="goPatentListView(item.row)"
                >{{ item.row.patentCount }}</el-link>
              </template>
            </el-table-column>

            <!-- <el-table-column
              prop="isAvaliable"
              :label="$t('formData.isAvaliable')"
              align="center"
              min-width="150"
              show-overflow-tooltip
            >
              <template
                slot-scope="item"
              >{{ item.row.isAvaliable == 0 ? $t("formData.enable") : item.row.isAvaliable == 1 ? $t("formData.disable") : '' }}</template>
            </el-table-column> -->

            <el-table-column
              prop="overdue"
              :label="$t('queryForm.whetherTheOverdue')"
              align="center"
              min-width="150"
              show-overflow-tooltip
            >
              <template
                slot-scope="item"
              >{{ item.row.overdue == 0 ? $t("queryForm.no") : item.row.overdue == 1 ? $t("queryForm.yes") : '' }}</template>
            </el-table-column>

            <el-table-column
              prop="latestProcessStatus"
              :label="$t('administration.Approvalstatus')"
              align="center"
              min-width="150"
              show-overflow-tooltip
            >
              <template
                slot-scope="item"
              >{{ item.row.latestProcessStatus == 1 ? $t("queryForm.pendingForApproval") : item.row.latestProcessStatus == 2 ? $t("queryForm.approved") : item.row.latestProcessStatus == 3 ? $t("administration.rejected") : item.row.latestProcessStatus == 4 ? $t("queryForm.draft") : '' }}</template>
            </el-table-column>

            <el-table-column
              prop="startStatus"
              :label="$t('administration.projectStatus')"
              align="center"
              min-width="150"
              show-overflow-tooltip
            >
              <template
                slot-scope="item"
              >{{ item.row.startStatus == 0 ? $t("administration.Notyetbegun") : item.row.startStatus == 1 ? $t("queryForm.inProgress") : item.row.startStatus == 2 ? $t("queryForm.completed") : '' }}</template>
            </el-table-column>

            <el-table-column
              prop="createUserName"
              :label="$t('queryForm.createdBy')"
              align="center"
              min-width="150"
              show-overflow-tooltip
            />
            <el-table-column
              class-name="tabAction"
              prop="tab7"
              :label="$t('formData.action')"
              align="center"
              width="100"
              min-width="100"
              fixed="right"
            >
              <template slot-scope="item">
                <el-dropdown @command="handleAction">
                  <span class="el-dropdown-link">
                    <!-- {{$t('formData.action')}}<i class="el-icon-arrow-down el-icon--right"></i> -->
                    <i class="el-icon-ali-TechnicalArea"></i>
                  </span>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item v-if="buttonPerCheck('view')" :command="{action:'openViewPage',param:[item.row.id]}">{{ $t("button.view") }}</el-dropdown-item>
                    <el-dropdown-item v-if="buttonPerCheck('edit')" :command="{action:'openEditPage',param:[item.row.id]}">{{ $t("button.edit") }}</el-dropdown-item>
                    <el-dropdown-item v-if="buttonPerCheck('delete')" :command="{action:'handleDelete',param:[item.$index, item.row]}">{{ $t("button.delete") }}</el-dropdown-item>
                    <el-dropdown-item v-if="buttonPerCheck('assign')" :command="{action:'openProjectPopUpView',param:[item.row]}">{{ $t("button.assign") }}</el-dropdown-item>
                    <el-dropdown-item divided v-if="buttonPerCheck('viewProcess')" :command="{action:'openProcessViewPage',param:[item.row.id]}">{{ $t("button.viewProcess") }}</el-dropdown-item>
                    <el-dropdown-item v-if="buttonPerCheck('editProcess')" :command="{action:'openProcessEditPage',param:[item.row.id]}">{{ $t("button.editProcess") }}</el-dropdown-item>
                    <el-dropdown-item divided v-if="buttonPerCheck('plan')" :command="{action:'openProjectUpdatePlanView',param:[item.row.id]}" :disabled="item.row.latestProcessStatus!==2">{{ $t("button.timeline") }}</el-dropdown-item>
                    <el-dropdown-item v-if="buttonPerCheck('implementing')" :command="{action:'openExcutePage',param:[item.row.id]}" :disabled="item.row.latestProcessStatus!==2" >{{ $t("button.implementing") }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </template>
        </table-page>
      </div>
    </card>
  </div>
</template>

<script>
import { baseProcessSelectStage } from "@/api/adminManagement";
import {
  projectSelectPage,
  projectImport,
  projectBatchDelete,
  projectBatchAvaliable
} from "@/api/projectManagement";
import { importExcelHelper } from "@/utils/excelImportHelper";
import axios from "axios";
import { getCreateUserList } from "@/api/adminManagement";
import { MyCompanyList } from "@/api/enumInfo";
export default {
  name: "ProjectListView",
  data() {
    return {
      dialogTableVisible: false,
      proId: "",
      multipleSelection: [],
      tableData: [],
      currentPage: 1,
      total: 0,
      formData: {
        companyId: "",
        projectCode: "",
        peojectName: "",
        keywords: "",
        technicalArea: "",
        developmentStatusCode: "",
        overdue: "",
        latestProcessStatus: "",
        startStatus: "",
        // isAvaliable: "",
        //createUserId: ""
      },
      formLabel: {
        companyId: "queryForm.companyName",
        projectCode: "queryForm.projectCode",
        peojectName: "queryForm.projectName",
        keywords: "queryForm.keywords",
        technicalArea: "queryForm.technicalArea",
        developmentStatusCode: "queryForm.projectDevelopmentStatus",
        overdue: "queryForm.whetherTheOverdue",
        latestProcessStatus: "administration.Approvalstatus",
        startStatus: "administration.projectStatus",
        // isAvaliable: "queryForm.isAvaliable",
        //createUserId: "queryForm.createdBy"
      },
      technicalAreaList: [],
      processSelectStageList: [],
      createUserList: [],
      myCompanyList: [],
      importLoading: false,
      loading: false,
      cloading: false
    };
  },
  computed: {
    lang() {
      return this.$store.state.app.language;
    }
  },
  watch: {
    lang() {
      this.getEnumsDictionariesList(1, this.technicalAreaList)
      // baseEnumsAvaliableTechnicalArea().then(res=>{
      //   this.technicalAreaList=res.data
      // })
    }
  },
  created() {},
  mounted() {
    const _self = this;
    this.getEnumsDictionariesList(1, this.technicalAreaList, function() {
    // baseEnumsAvaliableTechnicalArea().then(res=>{
      //  this.technicalAreaList=res.data;
      if (_self.$route.query.technicalArea) {
        _self.formData.technicalArea = _self.$route.query.technicalArea
        baseProcessSelectStage({
          technicalArea: _self.formData.technicalArea
        }).then(res => {
          _self.processSelectStageList = res.data
        });
      }
      if (_self.$route.query.developmentCode) {
        _self.formData.developmentStatusCode =
          _self.$route.query.developmentCode
      }
      if (_self.$route.query.companyName) {
        _self.formData.companyName = _self.$route.query.companyName;
      }
      _self.formData.overdue = _self.$route.query.overdue || "";
      if (_self.$route.query.latestProcessStatus != undefined) {
        _self.formData.latestProcessStatus = parseInt(
          _self.$route.query.latestProcessStatus
        );
      }
      if (_self.$route.query.isAvaliable != undefined) {
        _self.formData.isAvaliable = parseInt(_self.$route.query.isAvaliable)
      }
      // if (_self.$route.query.createUserId != undefined) {
      //   _self.createUserList = [
      //     {
      //       id: _self.$route.query.createUserId,
      //       name: _self.$store.state.user.userinfo.loginName
      //     }
      //   ];
      //   _self.formData.createUserId = _self.$route.query.createUserId;
      // }
      if (
        _self.$route.query.companyId != undefined &&
        _self.$route.query.companyName != undefined
      ) {
        _self.myCompanyList = [
          {
            id: parseInt(_self.$route.query.companyId),
            companyName: _self.$route.query.companyName
          }
        ];
        _self.formData.companyId = parseInt(_self.$route.query.companyId)
      }
      _self.Query.call(_self)
    })
  },
  methods: {
    /**
     * 打开分配弹窗
     */
    openProjectPopUpView(row) {
      const self = this;
      self.proId = row.id;
      self.$router.push({
        name: "projectPopUpView",
        query: {
          proId: self.proId,
          backToPage: "projectListView"
        }
      });
    },
    /**
     * 查询方法
     * @constructor
     */
    Query() {
      this.getData.call(this, 1, this.$refs.tablepage.pageSize);
    },
    getData(currentPage, pageSize, queryData) {
      this.currentPage = currentPage;
      if (!queryData) {
        queryData = { ...this.formData };
      }
      queryData.pageSize = pageSize;
      queryData.pageNum = currentPage;
      projectSelectPage(queryData).then(res => {
        if(res.code == 200){
          if(res.data){
            this.tableData = res.data.list;
            this.total = res.data.total;
          }
          else{
            this.tableData = [];
            this.total = 0;
          }
          this.$refs.tablepage.queryData = queryData;
        }
      });
    },
    /**
     * 重置
     * @constructor
     */
    Reset() {
      this.createUserList = [];
      this.myCompanyList = [];
      // console.log('重置')
    },

    /**
     * 监听分页
     */
    handleSearch(currentPage) {
      this.getData.call(
        this,
        currentPage,
        this.$refs.tablepage.pageSize,
        this.$refs.tablepage.queryData
      );
    },
    openAddProject() {
      this.$router.push({
        name: "projectAdd",
        query: {
          backToPage: "projectListView"
        }
      });
    },
    /**
     * 跳转到编辑页面
     */
    openViewPage(id) {
      this.$router.push({
        name: "projectView",
        query: {
          id: id,
          isView: 1,
          backToPage: "projectListView"
        }
      });
    },
    /**
     * 跳转到编辑页面
     */
    openEditPage(id) {
      this.$router.push({
        name: "projectAddEditView",
        query: {
          id: id,
          isEdit: 1,
          backToPage: "projectListView"
        }
      });
    },

    /**
     * table 选中事件
     * @param val
     */
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    /**
     * 跳转到查看项目流程页面
     */
    openProcessDetailPage(id) {
      this.$router.push({
        name: "projectProcessView",
        query: {
          id: id,
          backToPage: "projectListView"
        }
      });
    },

    /**
     * 跳转到查看项目流程页面
     */
    openProcessViewPage(id) {
      this.$router.push({
        name: "projectProcessView",
        query: {
          id: id,
          backToPage: "projectListView"
        }
      });
    },

    /**
     * 跳转到编辑项目流程页面
     */
    openProcessEditPage(id) {
      this.$router.push({
        name: "projectProcessEdit",
        query: {
          id: id,
          backToPage: "projectListView"
        }
      });
    },
    /**
     * 跳转到更新计划页面
     */
    openProjectUpdatePlanView(id) {
      this.$router.push({
        name: "projectUpdatePlanView",
        query: {
          id: id,
          backToPage: "projectListView"
        }
      });
    },

    /**
     * 跳转到项目执行页面
     */
    openExcutePage(id) {
      this.$router.push({
        name: "projectProcessExcute",
        query: {
          id: id,
          backToPage: "projectListView"
        }
      });
    },
    /**
     * tab 分页的 change 方法
     */
    changeTablePage(currentPage, pageSize) {
      this.$refs.tablepage.pageSize = pageSize;
      this.getData.call(
        this,
        currentPage,
        pageSize,
        this.$refs.tablepage.queryData
      );
    },
    // 技术领域change事件
    technicalAreaChange() {
      this.formData.developmentStatusCode = "";
      baseProcessSelectStage({
        technicalArea: this.formData.technicalArea
      }).then(res => {
        this.processSelectStageList = res.data;
      });
    },
    /**
     * 删除
     * @param index
     * @param row
     */
    handleDelete(index, row) {
      this.$confirm(
        this.$t("tipsList.deleteProjectWill"),
        this.$t("messageCommon.tips"),
        {
          confirmButtonText: this.$t("button.confirm"),
          cancelButtonText: this.$t("button.cancel"),
          type: "warning"
        }
      ).then(() => {
        projectBatchDelete([row.id])
          .then(result => {
            if (result.code == 200) {
              this.$message({
                type: "success",
                message: result.message
              });

              this.Query.call(this);
            } else {
              // this.$message({
              //   type: 'error',
              //   message: result.message
              // })
            }
          })
          .catch(() => {});
      });
    },
    /**
     * 批量删除
     */
    deleteBatch() {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: this.$t("messageCommon.selectAtLeastOne"),
          type: "warning"
        });
        return;
      }
      this.$confirm(
        this.$t("tipsList.deleteProjectWill"),
        this.$t("messageCommon.tips"),
        {
          confirmButtonText: this.$t("button.confirm"),
          cancelButtonText: this.$t("button.cancel"),
          type: "warning"
        }
      )
        .then(() => {
          const ids = [];
          this.multipleSelection.forEach(function(item) {
            ids.push(item.id);
          });
          projectBatchDelete(ids)
            .then(result => {
              if (result.code == 200) {
                this.$message({
                  type: "success",
                  message: result.message
                });

                this.Query();
              } else {
                // this.$message({
                //   type: 'error',
                //   message: result.message
                // })
              }
            })
            .catch(() => {});
        })
        .catch(() => {});
    },

    /**
     * 批量启用、禁用
     */
    enableBatch(isEnable) {
      if (this.multipleSelection.length === 0) {
        this.$message({
          message: this.$t("messageCommon.selectAtLeastOne"),
          type: "warning"
        });
        return;
      }
      // this.$confirm(
      //   this.$t("messageCommon.confirmDelete"),
      //   this.$t("messageCommon.tips"),
      //   {
      //     confirmButtonText: this.$t("button.confirm"),
      //     cancelButtonText: this.$t("button.cancel"),
      //     type: "warning"
      //   }
      // )
      //   .then(() => {
      const ids = [];
      this.multipleSelection.forEach(function(item) {
        ids.push(item.id);
      });
      const isEnableParam = isEnable ? 0 : 1;
      projectBatchAvaliable(ids, isEnableParam)
        .then(result => {
          if (result.code == 200) {
            this.$message({
              type: "success",
              message: result.message
            });

            this.Query();
          } else {
            // this.$message({
            //   type: 'error',
            //   message: result.message
            // })
          }
        })
        .catch(() => {});
      // })
      // .catch(() => {});
    },
    openImportPage() {
      importExcelHelper.call(this, file => {
        var postData = new FormData();
        postData.append("file", file);
        this.importLoading = true;
        projectImport(postData)
          .then(res => {
            if (res.code == 200) {
              this.$message({
                type: "success",
                message: res.message
              });

              this.Query.call(this);
            }
          })
          .catch(() => {
            this.$message({
              type: "error",
              message:
                this.$t("messageCommon.request") +
                this.$t("messageCommon.error")
            });
          })
          .finally(() => {
            this.importLoading = false;
          });
      });
    },
    downloadTemplate() {
      const baseUrl = axios.defaults.baseURL
      const languageCur = this.$store.state.app.language
      let templateUrl = baseUrl// + '/file/template/ProjectTemplate.xlsx'
      if(languageCur === 'en'){
        templateUrl += '/file/template/ProjectTemplate_EN.xlsx'
      }
      else{
        templateUrl += '/file/template/ProjectTemplate_CN.xlsx'
      }

      window.open(templateUrl);
    },

    /**
     * 跳转到专利列表页面
     */
    goPatentListView(data) {
      this.$router.push({
        name: "patentListView",
        query: {
          projectId: data.id,
          projectName: data.peojectName,
          mainType: 1
        }
      });
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        getCreateUserList({ name: query }).then(res => {
          this.loading = false;
          this.createUserList = res.data;
        });
      } else {
        this.createUserList = [];
      }
    },
    companyRemoteMethod(query) {
      if (query !== "") {
        this.cloading = true;
        MyCompanyList({ companyName: query }).then(res => {
          this.cloading = false;
          this.myCompanyList = res.data;
        });
      } else {
        this.myCompanyList = [];
      }
    },

    handleAction(command){
      switch(command.action){
        case 'openViewPage':
          this.openViewPage(command.param[0])
        break;
        case 'openEditPage':
          this.openEditPage(command.param[0])
        break;
        case 'handleDelete':
          this.handleDelete(command.param[0],command.param[1])
        break;
        case 'openProjectPopUpView':
          this.openProjectPopUpView(command.param[0])
        break;
        case 'openProcessViewPage':
          this.openProcessViewPage(command.param[0])
        break;
        case 'openProcessEditPage':
          this.openProcessEditPage(command.param[0])
        break;
        case 'openProjectUpdatePlanView':
          this.openProjectUpdatePlanView(command.param[0])
        break;
        case 'openExcutePage':
          this.openExcutePage(command.param[0])
        break;
      }
    }
  }
};
</script>

<style scoped lang="scss">
.el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
</style>
